"use strict";
import { __require as t } from "./index.es45.js";
import { __require as u } from "./index.es46.js";
import { __require as o } from "./index.es47.js";
var r, e;
function _() {
  if (e) return r;
  e = 1;
  var i = /* @__PURE__ */ t(), a = /* @__PURE__ */ u(), s = /* @__PURE__ */ o();
  return r = {
    formats: s,
    parse: a,
    stringify: i
  }, r;
}
export {
  _ as __require
};
//# sourceMappingURL=index.es44.js.map
